"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var IconButtonDropdown_styled_exports = {};
__export(IconButtonDropdown_styled_exports, {
  StyledIconButtonDropdownContentWrapper: () => StyledIconButtonDropdownContentWrapper,
  StyledIconButtonPopover: () => StyledIconButtonPopover,
  StyledIconButtonTitle: () => StyledIconButtonTitle
});
module.exports = __toCommonJS(IconButtonDropdown_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Popover = require("../../atoms/Popover/Popover.component");
var import_DropdownItem = require("../../atoms/DropdownItem/DropdownItem.styled");
var import_mixins = require("../../../themes/mixins");
var StyledIconButtonTitle = import_styled_components.default.div.withConfig({
  displayName: "IconButtonDropdownstyled__StyledIconButtonTitle",
  componentId: "sc-1sovble-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["i{line-height:1.6;font-weight:", ";font-size:", ";}"], theme.typography.weights.regular, theme.iconology.sizes.medium);
});
var StyledIconButtonDropdownContentWrapper = import_styled_components.default.div.withConfig({
  displayName: "IconButtonDropdownstyled__StyledIconButtonDropdownContentWrapper",
  componentId: "sc-1sovble-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;margin-right:", ";", "{font-size:", ";font-weight:450;color:", ";&:not(:first-of-type){border-top:1px solid ", ";}&:hover{background-color:", ";text-decoration:none;}&:focus{border:", " 2px solid;border-radius:0px;}&:focus + button{border-top:0px;}&:disabled{background:", ";cursor:not-allowed;color:", ";&:hover{background-color:", ";color:", ";}}}"], theme.measurements.large, import_DropdownItem.StyledDropdownItem, theme.typography.sizes.medium, theme.colors.n[100], theme.colors.beige[180], theme.colors.beige[100], theme.colors.beige[180], theme.colors.n[10], theme.colors.n[60], theme.colors.n[10], theme.colors.n[60]);
});
var StyledIconButtonPopover = (0, import_styled_components.default)(import_Popover.Popover).withConfig({
  displayName: "IconButtonDropdownstyled__StyledIconButtonPopover",
  componentId: "sc-1sovble-2"
})(function(_ref3) {
  var theme = _ref3.theme, maxHeight = _ref3.maxHeight;
  return (0, import_styled_components.css)(["max-height:", "px;list-style-type:none;overflow-y:overlay;padding:0;z-index:1;border-radius:4 px;border:1px solid ", ";", "::-webkit-scrollbar-thumb{border-right:1px solid transparent;background-clip:padding-box;}::-webkit-scrollbar{width:5px;height:5px;}::-webkit-scrollbar-thumb:hover{border:1px solid ", ";}::-webkit-scrollbar-track{width:9px;height:9px;margin:1vh;}"], maxHeight, theme.colors.beige[180], (0, import_mixins.withStyledScrollBar)({
    scrollbarWidth: "extraThin",
    scrollbarHeight: "extraThin",
    backgroundColor: "transparent",
    scrollbarColor: "".concat(theme.colors.black)
  }), theme.colors.black);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledIconButtonDropdownContentWrapper,
  StyledIconButtonPopover,
  StyledIconButtonTitle
});
//# sourceMappingURL=IconButtonDropdown.styled.js.map